import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './HomePage.css';

export default function HomePage() {
  const { t } = useTranslation();
  const [heroImageError, setHeroImageError] = useState(false);

  const links = [
    { to: '/music', key: 'nav.music' },
    { to: '/photos', key: 'nav.photos' },
    { to: '/videos', key: 'nav.videos' },
    { to: '/fanwall', key: 'nav.fanwall' },
    { to: '/merch', key: 'nav.merch' },
    { to: '/contact', key: 'nav.contact' },
  ];

  return (
    <div className="home-page">
      <div className="home-page__inner">
        {/* Hero: background + skull/face graphic (ASSETS_PLAN: hero section, skulls; UI_STYLE_GUIDE: hero section backgrounds) */}
        <section className="home-hero" aria-hidden="true">
          <div className={`home-hero__bg ${heroImageError ? 'home-hero__bg--no-image' : ''}`} />
          {!heroImageError ? (
            <img
              src="/skulls/hero.png"
              alt=""
              className="home-hero__graphic"
              onError={() => setHeroImageError(true)}
            />
          ) : (
            <div className="home-hero__fallback" />
          )}
        </section>

        <h1 className="home-page__title">{t('home.title')}</h1>
        <p className="home-page__subtitle">{t('home.subtitle')}</p>
        <nav>
          <ul className="home-page__nav">
            {links.map(({ to, key }) => (
              <li key={to}>
                <Link to={to}>{t(key)}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
